// Meat variants data
const meatVariants = [
  {
    id: 1,
    meat_id: 1, // Corned Beef
    name: 'Regular',
    price_adjustment: 0.00
  },
  {
    id: 2,
    meat_id: 1, // Corned Beef
    name: 'Lean',
    price_adjustment: 1.50
  },
  {
    id: 3,
    meat_id: 1, // Corned Beef
    name: 'Fatty',
    price_adjustment: 0.00
  },
  {
    id: 4,
    meat_id: 2, // Pastrami
    name: 'Regular',
    price_adjustment: 0.00
  },
  {
    id: 5,
    meat_id: 2, // Pastrami
    name: 'Lean',
    price_adjustment: 1.50
  },
  {
    id: 6,
    meat_id: 2, // Pastrami
    name: 'Fatty',
    price_adjustment: 0.00
  },
  // Removed salami variants since they're now separate items in the menu
  {
    id: 7,
    meat_id: 21, // Hot Dog
    name: '1/4 lb',
    price_adjustment: 0.00
  },
  {
    id: 8,
    meat_id: 21, // Hot Dog
    name: '1/2 lb',
    price_adjustment: 3.00
  },
  {
    id: 9, // Next available ID
    meat_id: 18, // Beef Tongue
    name: 'Regular',
    price_adjustment: 0.00
  },
  {
    id: 10, // Next available ID
    meat_id: 18, // Beef Tongue
    name: 'Lean',
    price_adjustment: 0.00
  }
];

export default meatVariants;